export default "__VITE_ASSET__08ae119a__"